import styled, { CSSObject } from 'styled-components';

interface OverlayStyledProps {
  sx?: CSSObject;
}

const OverlayStyled = styled.div<OverlayStyledProps>(({ sx }) => ({
  zIndex: 999999,
  backgroundColor: 'rgba(0, 0, 0, 0.35)',
  position: 'fixed',
  display: 'flex',
  alignItems: 'center',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  ...sx,
}));

export { OverlayStyled };
